/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminCompanyVerificationItemDto { 
    id?: number;
    companyName?: string;
    companyNo?: string;
    email?: string;
    phone1?: string;
    emailOwnershipStatus?: AdminCompanyVerificationItemDto.EmailOwnershipStatusEnum;
    emailDomain?: string;
    status?: AdminCompanyVerificationItemDto.StatusEnum;
    proofUploaded?: boolean;
    proofDocumentPath?: string;
    proofUploadedAt?: string;
    created?: string;
}
export namespace AdminCompanyVerificationItemDto {
    export type EmailOwnershipStatusEnum = 'AUTO_MATCHED' | 'FREE_MAIL' | 'UNMATCHED';
    export const EmailOwnershipStatusEnum = {
        AutoMatched: 'AUTO_MATCHED' as EmailOwnershipStatusEnum,
        FreeMail: 'FREE_MAIL' as EmailOwnershipStatusEnum,
        Unmatched: 'UNMATCHED' as EmailOwnershipStatusEnum
    };
    export type StatusEnum = 'PENDING' | 'VERIFIED' | 'REJECTED';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Verified: 'VERIFIED' as StatusEnum,
        Rejected: 'REJECTED' as StatusEnum
    };
}


